import { Component, Input, QueryList, ViewChildren, ViewChild } from '@angular/core';

import { BaseFormList, MessageService } from '../../../core';

import { Usuario } from '../../usuario/usuario';
import { UsuarioUnidadeNegocio } from '../../usuario/unidade-negocio/usuario-unidade-negocio';
import { TypeaheadUsuarioComponent } from '../../usuario/typeahead/typeahead-usuario.component';
import { UsuarioPopulaAgrupamentoPerfilModalComponent } from '../../usuario/popula/perfil/modal/usuario-popula-agrupamento-perfil-modal.component';

@Component({
    selector: 'sgt-unidade-negocio-usuario',
    templateUrl: './unidade-negocio-usuario.component.html',
    styleUrls: ['./unidade-negocio-usuario.component.less']
})
export class UnidadeNegocioUsuarioComponent implements BaseFormList<UsuarioUnidadeNegocio> {
    @Input() nomeUnidadeNegocio = '';
    @Input() entities: UsuarioUnidadeNegocio[];

    @ViewChildren('typeaheadUsuario') typeaheadsUsuarios: QueryList<TypeaheadUsuarioComponent>;
    @ViewChild('usuarioPopulaAgrupamentoPerfilModal') usuarioPopulaAgrupamentoPerfilModal: UsuarioPopulaAgrupamentoPerfilModalComponent;

    constructor(private messageService: MessageService) { }


    /** Ao alterar o usuário */
    onChangeUsuario(entity: UsuarioUnidadeNegocio, usuario: Usuario) {
        if (usuario) {
            entity.idUsuario = usuario.id;
        } else {
            entity.idUsuario = null;
        }
    }


    insert() {
        const entity = new UsuarioUnidadeNegocio();
        this.entities.push(entity);

        setTimeout(() => this.setFocusUsuario(), 200);
    }

    /** Seta o foco no typeahead do usuário ao inserir */
    private setFocusUsuario() {
        if (!this.typeaheadsUsuarios) {
            return;
        }
        // Obtendo o último select para setar o foco
        const typeaheadUsuario = this.typeaheadsUsuarios.last;
        if (typeaheadUsuario) {
            typeaheadUsuario.setFocus();
        }
    }

    delete(index: number) {
        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente remover o acesso do usuário ${entity?.usuario?.nome} a unidade de negócio ${this.nomeUnidadeNegocio}?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se os usuários estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];


            const count = this.entities.filter(entityFilter => entityFilter.idUsuario && entityFilter.idUsuario === entity.idUsuario).length;
            if (count > 1) {
                this.messageService.info(`O usuário ${entity?.usuario?.nome} já está adicionado. Remova ou altere o usuário duplicado`, 'Não é possível adicionar o mesmo usuário mais de uma vez');
                return false;
            }
        }

        return true;
    }

    /** Resolve os usuários da unidade de negócio */
    resolve() {
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idUsuario) {
                this.entities.splice(i, 1);
            }
        }
    }

    /** Abre o modal para adicionar e popular os usuários */
    openUsuarioPopulaAgrupamentoPerfilModal() {
        this.usuarioPopulaAgrupamentoPerfilModal?.open();
    }

    /** Obtem o sub-título para o modal de popular os usuários */
    getSubtitleUsuarioPopulaAgrupamentoPerfilModal(): string {
        return `Selecione os usuários que devem ter acesso e visibilidade a unidade de negócio ${this.nomeUnidadeNegocio}`;
    }

    /** Ao adicionar os usuários através do modal de popula */
    onAdicionarUsuarios(usuarios: Usuario[]) {
        usuarios?.forEach(usuario => {
            const entity = new UsuarioUnidadeNegocio();
            entity.idUsuario = usuario.id;
            entity.usuario = usuario;

            this.entities.push(entity);
        });
    }
}
